// extracted by mini-css-extract-plugin
export default {"flex":"referrals_flex__lsSXW","grid":"referrals_grid__Nq1cx","info":"referrals_info__ndYXW","cards":"referrals_cards__44-7T"};